module.exports = __webpack_public_path__ + "img/device_1015_2_select.47b64ab8.svg";